import { render, staticRenderFns } from "./ClassByCourse.vue?vue&type=template&id=6e42fcf5&scoped=true"
import script from "./ClassByCourse.vue?vue&type=script&lang=js"
export * from "./ClassByCourse.vue?vue&type=script&lang=js"
import style0 from "./ClassByCourse.vue?vue&type=style&index=0&id=6e42fcf5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e42fcf5",
  null
  
)

export default component.exports